"use strict";
var eq = require('./eq');
function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
        if (eq(array[length][0], key)) {
            return length;
        }
    }
    return -1;
}
module.exports = assocIndexOf;
//# sourceMappingURL=_assocIndexOf.js.map